import o from "./typeof.js";
import e from "./toPrimitive.js";
function f(t) {
  var r = e(t, "string");
  return o(r) === "symbol" ? r : String(r);
}
export {
  f as default
};
//# sourceMappingURL=toPropertyKey.js.map
